export function fetchProduct(gid) {
	return fetch(
		process.env.REACT_APP_BASE_API + 'order/apis/getProducts.php?gid=' + gid
	)
}